export default __webpack_public_path__ + "static/media/icon-social-share.cf3d3120.png";